import {Box, Typography} from "@mui/material";
import {TabPanel} from "../../../components/tab-panel-comp";
import {useTranslation} from "react-i18next";


export const TabReviews = ({tabValue, distributor}) => {
    const {t} = useTranslation();
    return (
        <TabPanel value={tabValue} index={5} typePanel="distributor">
            <Box sx={{textAlign: "center", py: 4}}>
                <Typography variant="h6" gutterBottom>
                    {t("ReviewsComingSoon")}
                </Typography>
                <Typography variant="body1">{t("ReviewsFeatureDescription")}</Typography>
            </Box>
        </TabPanel>
    )
}